import { defineMessages } from 'react-intl';

const scope = 'app.widgets.InventoryBlocks';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Inventory Blocks',
    },
    noData: {
        id: `${scope}.noDataMessage`,
        description: 'Message shown when there is no data to show',
        defaultMessage: 'No existing data for the period.',
    },
});
